export enum SavingState {
  Idle = 'IDLE',
  Saving = 'SAVING',
  Success = 'SUCCESS',
  Error = 'ERROR',
}

export enum TemplateType {
  BASIC = 'Basic',
  MEDIUM = 'Medium',
  EXTRA = 'Extravaganza',
}

export enum ScreenType {
  Overview = 'OVERVIEW',
  AddSection = 'ADD_SECTION',
  Header = 'HEADER',
  IntroductionText = 'INTRODUCTION_TEXT',
  Footer = 'FOOTER',
}

export type Section = PrismaJson.CollectionSection;
export type SectionProps = Omit<Section, 'type'>;
